/* import __COLOCATED_TEMPLATE__ from './composer-help-modal.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class extends Component {
  @tracked showModal = false;
}
